﻿export const dropzone = (function () {
    class Dropzone {
        constructor(name = 'my', multiple = true) {
            this._name = name;
            this.name;

            this._form = document.createElement('form');
            this._label = document.createElement('label');
            this._input = document.createElement('input');
            const dropzoneBlock = document.createElement('div');
            const dropzoneCaption = document.createElement('span');

            this._form.appendChild(this._label);
            this._form.appendChild(this._input);
            this._form.appendChild(dropzoneBlock);
            dropzoneBlock.appendChild(dropzoneCaption);

            this._form.name = this._name;
            this._form.method = 'POST';
            this._form.action = '';
            this._form.classList.add('dropzone');
            this._form.classList.add('mx-auto');
            this._form.id = `${this._name}-container`;
            this._form.enctype = 'multipart/form-data';

            this._input.id = `${this._name}-file-input`;
            this._input.classList.add('dropzone-input');
            this._input.classList.add('form-control-file');
            this._input.type = 'file';
            this._input.name = 'file';

            if (multiple) {
                this._input.setAttribute('multiple', '');
                this._input.setAttribute('aria-describedby', 'multiple-upload');
            }

            this._label.setAttribute('for', `${this._name}-file-input`);
            this._label.classList.add('dropzone-label');
            this._label.textContent = 'Выберите файл';

            dropzoneBlock.classList.add('dropzone-box');
            dropzoneBlock.classList.add('text-center');
            dropzoneCaption.textContent = 'или перетащите его сюда';
            dropzoneCaption.classList.add('dropzone-caption');
        }

        init(callback) {
            document.addEventListener('drag', e => {

            }, false);

            document.addEventListener('dragstart', e => {
                dragged = event.target;
                event.target.style.opacity = .5;
            }, false);

            document.addEventListener('dragend', e => {
                event.target.style.opacity = '';
            }, false);

            document.addEventListener('dragover', e => {
                event.preventDefault();
            }, false);

            document.addEventListener('dragenter', e => {
                if (e.target == this._form) {
                    e.target.classList.add('dragover');
                }
            }, false);

            document.addEventListener('dragleave', e => {
                if (e.target == this._form) {
                    e.target.classList.remove('dragover');
                }
            }, false);

            document.addEventListener('drop', e => {
                event.preventDefault();

                if (e.target == this._form) {
                    e.target.classList.remove('dragover');
                    let files = e.dataTransfer.files;
                    callback(files);
                }
            }, false);

            this._input.addEventListener('change', e => {
                let files = e.target.files;
                callback(files);
            });

            this._input.addEventListener('focus', () => {
                this._label.classList.add('focus');
            });

            this._input.addEventListener('blur', () => {
                this._label.classList.remove('focus');
            });
        }

        get name() {
            return this._name;
        }

        set name(value) {
            this._name = value;
            this._form.name = this._name;
            this._form.id = `${this._name}-container`;
            this._input.id = `${this._name}-file-input`;
            this._label.for = `${this._name}-file-input`;
        }

        getForm() {
            return this._form;
        }
    };

    return {
        Dropzone
    };
})();